
import './index.scss';
import React, { Component } from 'react';
import { PropTypes } from 'prop-types';


class Checkbox extends Component {

  toggleCheckboxChange = () => {

      const { handleCheckboxChange, value } = this.props;

      handleCheckboxChange( value );

  }

  render () {

      const { label } = this.props;
      const cvalue = this.props.value;

      return (
          <div className={`checkbox-li ${this.props.className ? this.props.className : ''}`}>
              <div className="checkbox-label">
                  <input
                      className="styled-checkbox"
                      type="checkbox"
                      value={cvalue}
                      checked={this.props.isChecked}
                      onChange={this.toggleCheckboxChange}
                      disabled={this.props.isDisabled}
                      id={`styled-checkbox-${this.props.id}`}

                  />

                  <label htmlFor={`styled-checkbox-${this.props.id}`}>{label}</label>
              </div>
          </div>
      );

  }

}
Checkbox.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    isChecked: PropTypes.bool.isRequired,
    id: PropTypes.string.isRequired,
    handleCheckboxChange: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool,
    className: PropTypes.string,
};
export default Checkbox;
